import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as detailInspectionActions from '../../actions/detail_inspection/index.js';

/* Components */
import Modal from '../../components/common/inspections/modal';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class DetailInspection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paramInspection: props.match.params.id_inspection
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('form');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('form')) {
          // call to the fetch api of specific Form
          await this.props.actions.fetchDetailInspectionApi({
            id: this.state.paramInspection
          });
          await this.props.actions.fetchDetailInspectionImgApi({
            id: this.state.paramInspection
          });
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  // we load the reset function, return the states to their initial state
  componentWillUnmount() {
    this.props.actions.resetDetailInspection();
  }

  render() {
    // the setting object is obtained which we use for the configuration
    const lang = localStoreFN().getItem('lang');
    const obj = JSON.parse(this.props.setting.value);
    // condition done to see if the setting was done
    if (this.props.setting) {
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (this.props.status === 401) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (this.props.status === 200) {
        container = (
          <div className="main-container scroll">
            <Modal
              languageFormat={lang}
              loading={this.props.loading}
              status={this.props.status}
              datos={this.props.datos.main}
              loadingImg={this.props.loadingImg}
              statusImg={this.props.statusImg}
              datosImg={this.props.datosImg}
              main={'1'}
              severityFailsColor={obj.form.severityFailsColor}
              question={this.props.datos.question}
              handleModal={function() {}}
              modalRight={true}
              fullscreen={true}
            />
            <Tooltip placement="top" id="pageTooltip" />
          </div>
        );
        // the 500 status of the application
      } else if (this.props.status === 500) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return <section className="main">{container}</section>;
    }
    // in case the setting is not loaded
    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,
  datos: state.reducer.detailInspection.datos,
  datosImg: state.reducer.detailInspection.datosImg,
  loading: state.reducer.detailInspection.loading,
  loadingImg: state.reducer.detailInspection.loadingImg,
  status: state.reducer.detailInspection.status,
  statusImg: state.reducer.detailInspection.statusImg,

  language: state.reducer.dashboard.language
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(detailInspectionActions, dispatch)
});

DetailInspection.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadingImg: PropTypes.bool.isRequired,
  datos: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired,
  datosImg: PropTypes.oneOfType([PropTypes.array, PropTypes.number, PropTypes.object]).isRequired,
  setting: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  status: PropTypes.number,
  statusImg: PropTypes.number,
  actions: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired
};

DetailInspection.defaultProps = {
  status: null,
  statusImg: null,
  statusTags: null
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailInspection);



// WEBPACK FOOTER //
// ./source/client/containers/detail_inspection/index.jsx